import { format } from 'date-fns';

export function getDefaultAudioFileName(): string {
  const date = format(new Date(), 'yyyy-MM-dd_hh:mm:ss');
  return `${date}.mp3`;
}
